"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

// Copyright © 2020 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var ApplicationPackages = /*#__PURE__*/function () {
  function ApplicationPackages(registry) {
    (0, _classCallCheck2["default"])(this, ApplicationPackages);
    this._api = registry;
    (0, _autoBind["default"])(this);
  }

  (0, _createClass2["default"])(ApplicationPackages, [{
    key: "getDefaultAssociation",
    value: function () {
      var _getDefaultAssociation = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(appId, fPort, selector) {
        var result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._api.GetDefaultAssociation({
                  routeParams: {
                    'ids.application_ids.application_id': appId,
                    'ids.f_port': fPort
                  }
                }, _marshaler["default"].selectorToFieldMask(selector));

              case 2:
                result = _context.sent;
                return _context.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getDefaultAssociation(_x, _x2, _x3) {
        return _getDefaultAssociation.apply(this, arguments);
      }

      return getDefaultAssociation;
    }()
  }, {
    key: "setDefaultAssociation",
    value: function () {
      var _setDefaultAssociation = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(appId, fPort, patch) {
        var mask,
            result,
            _args2 = arguments;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                mask = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : _marshaler["default"].fieldMaskFromPatch(patch, this._api.SetDefaultAssociationAllowedFieldMaskPaths);
                _context2.next = 3;
                return this._api.SetDefaultAssociation({
                  routeParams: {
                    'default.ids.application_ids.application_id': appId,
                    'default.ids.f_port': fPort
                  }
                }, {
                  "default": patch,
                  field_mask: _marshaler["default"].fieldMask(mask)
                });

              case 3:
                result = _context2.sent;
                return _context2.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setDefaultAssociation(_x4, _x5, _x6) {
        return _setDefaultAssociation.apply(this, arguments);
      }

      return setDefaultAssociation;
    }()
  }, {
    key: "deleteDefaultAssociation",
    value: function () {
      var _deleteDefaultAssociation = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(appId, fPort) {
        var result;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._api.DeleteDefaultAssociation({
                  routeParams: {
                    'application_ids.application_id': appId,
                    f_port: fPort
                  }
                });

              case 2:
                result = _context3.sent;
                return _context3.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function deleteDefaultAssociation(_x7, _x8) {
        return _deleteDefaultAssociation.apply(this, arguments);
      }

      return deleteDefaultAssociation;
    }()
  }]);
  return ApplicationPackages;
}();

var _default = ApplicationPackages;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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